import type { LobbyManager } from "./lobbyManager";

/**
 * Quickmatch: try to join the first open lobby with a free slot.
 * If none available, create a new lobby instead.
 */
export async function quickmatch(
  lobbyManager: LobbyManager
): Promise<{ lobbyId: string | null; error: string | null }> {
  const { lobbies: openLobbies, error: fetchError } = await lobbyManager.fetchOpenLobbies(
    "quickmatch",
    {
      fallbackMessage: "FAILED TO FIND MATCH",
      networkMessage: "NETWORK FAILED TO FIND MATCH"
    }
  );
  if (fetchError != null) {
    return { lobbyId: null, error: fetchError };
  }

  // Try to join the first lobby that has < 2 players
  for (const lobby of openLobbies) {
    if (lobby.players.length < 2) {
      const result = await lobbyManager.joinExistingLobby(lobby.id, {
        fallbackMessage: "FAILED TO FIND MATCH",
        networkMessage: "NETWORK FAILED TO FIND MATCH"
      }, lobby.queueType);
      if (result.error == null) {
        return { lobbyId: lobby.id, error: null };
      }
      if (
        result.error !== "LOBBY FULL"
        && result.error !== "LOBBY NOT AVAILABLE"
        && result.error !== "LOBBY NOT FOUND"
      ) {
        return { lobbyId: null, error: result.error };
      }
    }
  }

  // No open lobby available — create a new one
  return lobbyManager.createAndJoinLobby(undefined, "quickmatch");
}
